module.exports = __webpack_public_path__ + "static/monitoraea_4-3e0ed70a7b38e4319ddd50ff49eee30a.png";